import React from 'react';
import {useHistory, useLocation} from "react-router-dom";

import Icon from '../Icon';
import Description from '../Description';
import ContentMenu from "../ContentMenu";
import {KnowledgeTypeList} from "../../../constants";
import IconCard from '../IconCard';

import './index.scss';

const PageTitle = ({heading, description, icon, isSolution = true}) => {
    const history = useHistory();
    const {pathname} = useLocation();

    const showButton = pathname.includes('business-development') || pathname.includes('law') || pathname.includes('sports-and-gaming') || pathname.includes('other')

    return (
        <div className={`page-title-block ${isSolution ? '' : 'bg'}`}>
            <div className="container-layout">
                <div className="page-title-inner">
                    {icon ? <IconCard icon={icon}/> : null}
                    <h1 className="page-title">{heading}</h1>
                    <p className="page-title-txt">{description}</p>
                    {showButton && (
                        <div className="page-title-button">
                            <button className="filled green" type="button" onClick={() => history.push("/request-demo")}>
                                Request Demo
                            </button>
                        </div>
                    )}
                </div>

                {/*<div className="solutions-content-wrapper">*/}
                {/*	<div className="container-layout">*/}
                {/*		<div className="solutions-container">*/}
                {/*			<ContentMenu menuItems={KnowledgeTypeList} selected={solutionSlug}/>*/}
                {/*			<div className="content-item">*/}
                {/*				{*/}
                {/*					KnowledgeTypeList.map(solution => {*/}
                {/*						return (*/}
                {/*							<div id={solution.slug} key={solution.slug}>*/}
                {/*								<p className="solutions-menu-title">{solution.name}</p>*/}
                {/*								<p className="solutions-menu-t-txt">{solution.description}</p>*/}
                {/*								{*/}
                {/*									solution.nestedSubMenu?.products &&*/}
                {/*									<>*/}
                {/*										<div className="solutions-menu-inner">*/}
                {/*											{*/}
                {/*												solution.nestedSubMenu?.products.map(nestedSubItem =>*/}
                {/*													<div className="solutions-menu-i-row" key={nestedSubItem.name}>*/}
                {/*														<div className="solutions-menu-i-top">*/}
                {/*															<Link to={'/' + nestedSubItem.path}*/}
                {/*																  className="text-capitalize">{nestedSubItem.name}</Link>*/}
                {/*														</div>*/}
                {/*														<p className="solutions-menu-i-txt">{nestedSubItem.description}</p>*/}
                {/*													</div>*/}
                {/*												)*/}
                {/*											}*/}
                {/*										</div>*/}
                {/*									</>*/}
                {/*								}*/}
                {/*							</div>*/}
                {/*						);*/}
                {/*					})*/}
                {/*				}*/}
                {/*			</div>*/}
                {/*		</div>*/}
                {/*	</div>*/}
                {/*</div>*/}
            </div>
        </div>
    )
};

export default PageTitle;
